export enum WeightUnit {
    LBS = "lbs",
    KG = "kg",
}
